module.exports = __webpack_public_path__ + "static/media/coffee.90849ea9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/coffee.svg
// module id = 231
// module chunks = 0